export const ACTION_TYPE = 'actionType';
export const LIST_ID = 'listId';
export const SHOULD_ADD = 'shouldAdd';